export default { mapBuildVersion: "5.1.1" };
